<template>
  <div :id="`${source}_call_forwarding_toggle`" class="px-3">
    <a-switch size="small" :checked="isEnabled" @change="handleSwitchChange" />
  </div>
</template>

<script setup>
import { ref } from "vue";
import { message } from "ant-design-vue";
import DashboardService from "@/src/api/DashboardService.js";

const props = defineProps({
  source: { type: String, required: true, default: "custom_table" },
  row: { type: Object, required: true },
});

const isEnabled = ref(props.row?.is_active === true);

const handleSwitchChange = async (checked) => {
  try {
    isEnabled.value = checked;

    const payload = {
      state: checked,
    };

    const response = await DashboardService.toggleAPIAccess(
      props.row?.id,
      payload,
    );
    if (response?.success) {
      message.success(
        `'${props.row?.name}' is now ${checked ? "enabled" : "disabled"}!!`,
      );
    }
  } catch (error) {
    isEnabled.value = !checked;
    console.error("An error occurred while updating api key access: ", error);
    message.error(
      error?.response?.data?.error ||
        "An error occurred while updating api key access",
    );
  }
};
</script>
